import { IconButton } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useState } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { ProviderSubmit } from '../../types/accommodationProviderSubmit'
import ProviderARIRow from './ProviderARIRow'
import useStyles from './Styles/ProviderARI.style'

interface ProviderARIProps {
  selectedProviderSubmit: ProviderSubmit[]
  setSelectedProviderSubmit: React.Dispatch<
    React.SetStateAction<ProviderSubmit[]>
  >
  selectedProviderSubmitIndex: number
}

export default function ProviderARI({
  selectedProviderSubmit,
  setSelectedProviderSubmit,
  selectedProviderSubmitIndex
}: ProviderARIProps) {
  const classes = useStyles()
  const [clickOnConnections, setClickOnConnections] = useState(false)

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <SectionTitle title="ARI Retrieval" marginBottom />
        <IconButton
          className={classes.iconButton}
          onClick={() => {
            setClickOnConnections(!clickOnConnections)
          }}>
          {clickOnConnections ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </div>
      {clickOnConnections &&
        selectedProviderSubmit[selectedProviderSubmitIndex].ARIRetrievals.map(
          (_, ariIndex) => (
            <ProviderARIRow
              selectedProviderSubmit={selectedProviderSubmit}
              setSelectedProviderSubmit={setSelectedProviderSubmit}
              selectedProviderSubmitIndex={selectedProviderSubmitIndex}
              ariIndex={ariIndex}
            />
          )
        )}
    </div>
  )
}
